import { ApiLinkEntity, ApiLinkRel } from "config/constants";
import { IApiLink } from "@/types";

export interface IGetCommissionsDto {
    commissionRental?: number | null
    commissionSales?: number | null
    links: IApiLink[]
}

export interface IUpdateCommissionsDto {
    commissionRental: number | null
    commissionSales: number | null
}

export default class Commissions {
    commissionRental: number | null
    commissionSales: number | null
    linkUpdateCommissions?: IApiLink | null

    constructor(data: IGetCommissionsDto) {
        this.commissionRental = data.commissionRental || null
        this.commissionSales = data.commissionSales || null
        this.linkUpdateCommissions = data.links.find(link => link.entity === ApiLinkEntity.commission && link.rel === ApiLinkRel.update)
    }
}
